import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../../store/actions/actions";
import HeaderRun from "./Header.run";
import SnackbarWrapper from "../Common/SnackbarWrapper";
import { logoutUser } from "../../store/actions/actions";

import { Navigate } from "react-router-dom";
import "./styles.scss";

class Header extends Component {
  state = {
    isRedirect: false,
    dateBoolean: false,
    isOpen: false,
    isEvents: false,
    isAbout: false,
    isEditLeaderBoard: false,
    isUsers: false,
    isMenuOpen: false,
    currentPage: null,
  };

  componentDidMount() {
    HeaderRun();
    const date = new Date();
    const Dated = new Date("10/25/2024");
    if (date < Dated) {
      this.setState({
        dateBoolean: true,
      });
    } else {
      this.setState({
        dateBoolean: false,
      });
    }
  }

  // toggleOffsidebar = (e) => {
  //   e.preventDefault();
  //   this.props.actions.toggleSetting("offsidebarOpen");
  // };

  toggleCollapsed = (e) => {
    e.preventDefault();
    this.props.actions.toggleSetting("isCollapsed");
    this.resize();
  };

  toggleAside = (e) => {
    e.preventDefault();
    this.props.actions.toggleSetting("asideToggled");
  };

  resize() {
    // all IE friendly dispatchEvent
    var evt = document.createEvent("UIEvents");
    evt.initUIEvent("resize", true, false, window, 0);
    window.dispatchEvent(evt);
    // modern dispatchEvent way
    // window.dispatchEvent(new Event('resize'));
  }

  handleLogOut = (e) => {
    const { logoutUser } = this.props;
    logoutUser();
  };

  handleProfile = () => {
    this.setState({
      isRedirect: true,
    });
  };

  helpRedirect = () => {
    this.setState({
      isHelpRedirect: true,
    });
  };

  handleAbout = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/About") {
      this.setState({
        isAbout: true,
      });
    }
  };

  handleEvents = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/events") {
      this.setState({
        isEvents: true
      });
    }
  };

  handleCreateEvent = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/CreateEvents") {
      this.setState({
        isCreateEvent: true,
      });
    }
  };
  hanldeLeaderBoard = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/EventLeaderBoard") {
      this.setState({
        isLeaderBoard: true,
      });
    }
  };
  handleEditLeaderBoard = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/Evaluate") {
      this.setState({
        isEditLeaderBoard: true,
      });
    }
  };
  handleUsers = (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/Users") {
      this.setState({
        isUsers: true,
      });
    }
  };

  setIsOpen = (data) => {
    this.setState({
      isMenuOpen: data
    })
  }
  

  render() {
    const { currentEventId, profileDetails, isAuth } = this.props;

    const { isHelpRedirect, isRedirect, isAbout, isCreateEvent, isEvents, isLeaderBoard, isEditLeaderBoard, isUsers, isMenuOpen } = this.state;

    let content = null;
    if (!(isAuth)) {
      content = <Navigate to="/" />;
    } 
    else if(isAbout){
      content = <Navigate to={`/About`} />;
      this.setState({
        isAbout: false,
      })
    } 
    else if(isCreateEvent){
      content = <Navigate to={`/CreateEvents`} />;
      this.setState({
        isCreateEvent: false,
      })
    } 
    else if(isLeaderBoard){
      content = <Navigate to={`/EventLeaderBoard`} />;
      this.setState({
        isLeaderBoard: false,
      })
    } 
    else if(isEditLeaderBoard){
      content = <Navigate to={`/Evaluate`} />;
      this.setState({
        isEditLeaderBoard: false,
      })
    } 
    else if(isUsers){
      content = <Navigate to={`/Users`} />;
      this.setState({
        isUsers: false,
      })
    } 
    else if(isHelpRedirect){
      content = <Navigate to={`/ContactUs`} />;
      this.setState({
        isHelpRedirect: false,
      })
    } 
    else if(isRedirect){
      content = <Navigate to={`/Profile`} />
      this.setState({
        isRedirect: false,
      })
    } 
    else if(isEvents){
      content = <Navigate to={`/events`} />;
      this.setState({
        isEvents: false,
      })
    }
    

   return (
  //  !(isAuth) ? (
  //     <Navigate to={`/login`} />
  //   ) :
  //     isAbout ? (
  //       <Navigate to={`/About`} />
  //     ) :
  //       isCreateEvent ? (
  //         <Navigate to={`/CreateEvents`} />
  //       ) :
  //         isLeaderBoard ? (
  //           <Navigate to={`/EventLeaderBoard`} />
  //         ) :
  //           isEditLeaderBoard ? (
  //             <Navigate to={`/Evaluate`} />
  //           ) :
  //             isUsers ? (
  //               <Navigate to={`/Users`} />
  //             ) :
  //               isHelpRedirect ? (
  //                 <Navigate to={`/ContactUs`} />
  //               ) : isRedirect ? (
  //                 <Navigate to={`/profile/${currentProfile.userId}`} />
  //               ) : isEvents ?
  //                 (<Navigate to={`/events`} />) : (

                    <Fragment>
                        {content}
                      <header className="topnavbar-wrapper">
                        {/* START Top Navbar */}
                        <nav className="navbar topnavbar">
                          {/* START navbar header */}
                          <img
                            className="img-fluid ml-4 mr-2"
                            src="img/logo.png"
                            alt="App Logo"
                            style={{width:"170px", height:"auto"}}
                          />
                          <ul className="ml-3 navbar-nav flex1-row flex" >
                            <li className="mr-1 mt-2">
                              <button
                                className={
                                  ((window.location.pathname === "/events") || (window.location.pathname === "/eventQuest") || (window.location.pathname === "/ViewQuestion") || (window.location.pathname === "/ViewGame")) ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                onClick={(e) => this.handleEvents(e)}>
                                 <em className="fa fa-calendar"></em>&nbsp; Events
                              </button>
                            </li>
                            <li className="mr-1 mt-2">
                              {currentEventId
                                ? <button className={window.location.pathname === "/EventLeaderBoard" ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                  onClick={(e) => this.hanldeLeaderBoard(e)}
                                  disabled={currentEventId ? false : true}
                                >
                                  <em className="fa-solid fa-ranking-star"></em>&nbsp;Leaderboard
                                </button>
                                : ""
                              }

                            </li>
                            {(profileDetails && profileDetails.role === "Organizer") || (profileDetails && profileDetails.role === "Admin") ?
                              <li className="mr-1 mt-2">
                                <button
                                  className={
                                    ((window.location.pathname === "/CreateEvents") || (window.location.pathname === "/CreateNewEvent") || (window.location.pathname === "/AddQuestions")) ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                  onClick={(e) => this.handleCreateEvent(e)}>
                                   <em className="	far fa-calendar-plus"></em>&nbsp; Create Events
                                </button>
                              </li> : ""}
                            {(profileDetails && profileDetails.role !== "User") ?
                              <li className="mr-1 mt-2">
                                <button
                                  className={window.location.pathname === "/Evaluate" ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                  onClick={(e) => this.handleEditLeaderBoard(e)}>
                                  <em className="fa fa-check-square"></em>&nbsp; Evaluate
                                </button>
                              </li> : ""}
                            {(profileDetails && profileDetails.role === "Admin") ?
                              <li className="mr-1 mt-2">
                                <button className={window.location.pathname === "/Users" ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                  onClick={(e) => this.handleUsers(e)}>
                                  <em className="fa fa-user-friends"></em>&nbsp; Users
                                </button>
                              </li> : ""}   
                              <li className="mr-1 mt-2">
                              <button
                                className={
                                  window.location.pathname === "/About" ? "Header-Active-Button py-2 px-4" : "Header-button  py-2 px-4"}
                                onClick={(e) => this.handleAbout(e)}>
                                <em className="fa fa-info-circle"></em>&nbsp; About
                              </button>
                            </li>
                          </ul>

                          {/* END navbar header */}
                          {/* START Right Navbar */}
                          <ul className="navbar-nav flex-row">
                            &nbsp;
                            <li className="nav-item mb-1">
                              <div className="nav-link" style={{ pointerEvents: "none" }}>

                                {/* <a className="nav-link" href="/CreateEvents"><em className="fa fa-user"></em></a> */}
                              </div>
                            </li>
                            {/* <li>
                              <a className="nav-link" href="/CreateEvents"><em className="fa fa-user"></em></a>
                            </li> */}
                            <li className="nav-item mb-1 mr-2">
                              <button style={{background:"transparent", border:"0"}}
                                className="nav-link"
                                onClick={(e) => this.handleProfile(e)}
                              >
                                <em className="fa fa-user"></em>&nbsp;  {profileDetails && profileDetails.userName}
                              </button>
                            </li>
                            {/* <li className="nav-item mb-1">
                      {" "}
                      {
                        !errorInUpdate && ( // handled as hyperlink because if we use redirect url, if the same page is loaded again and again, there is an error.(so commented the redirecting code)
                          <a className="nav-link" href={`/ContactUs`}>
                            <em className="fa fa-question-circle"></em> &nbsp;Help
                          </a>
                        )
                        // <span style={{color: "white", cursor: "Pointer"}} onClick={this.helpRedirect}><em className="fa fa-headset"></em>&nbsp;Help</span>
                      }
                    </li> */}
                            &nbsp;
                            <li className="nav-item mb-1 mr-2">
                              <a
                                className="nav-link"
                                href="/"
                                onClick={(e) => this.handleLogOut(e)}
                              >
                                <em className="fa fa-sign-out"></em>&nbsp;Log out
                              </a>
                            </li>
                          </ul>
                          <div className="hamburger-container">
                            <button style={{color:"white"}} className={`hamburger ${isMenuOpen ? "open" : ""}`} onClick={() => this.setIsOpen(!isMenuOpen)}>
                              <span></span>
                              <span></span>
                              <span></span>
                            </button>
                            {/* {isOpen ? */}
                            <nav className={`menu ${isMenuOpen ? "show" : ""}`}>
                              <ul>
                                <li  onClick={(e) => this.handleEvents(e)}><em className="fa fa-calendar"></em>&nbsp;&nbsp;&nbsp; Events</li>
                                {currentEventId ? <li onClick={(e) => this.hanldeLeaderBoard(e)}><em className="fa-solid fa-ranking-star"></em>&nbsp; Leaderboard</li> : ""}
                                {(profileDetails && profileDetails.role === "Organizer") || (profileDetails && profileDetails.role === "Admin") ?<li  onClick={(e) => this.handleCreateEvent(e)}><em className="fa fa-calendar-plus"></em>&nbsp;&nbsp;&nbsp; Create Events</li> : ""} 
                                {(profileDetails && profileDetails.role !== "User") ? <li  onClick={(e) => this.handleEditLeaderBoard(e)}><em className="fa fa-check-square"></em>&nbsp;&nbsp;&nbsp; Evaluate</li>: ""}
                                {(profileDetails && profileDetails.role === "Admin") ?<li  onClick={(e) => this.handleUsers(e)}><em className="fa fa-user-friends"></em>&nbsp; Users</li>:""}
                                <li  onClick={(e) => this.handleAbout(e)}><em className="fa fa-info-circle"></em>&nbsp;&nbsp;&nbsp;About</li>
                                <li style={{height:"1px", background:"#00456c", padding:"0px"}}><span></span></li>
                                <li><a href="/Profile"><em className="fa fa-user" ></em>&nbsp;&nbsp;&nbsp;<span style={{color:"#00456c"}}>{profileDetails && profileDetails.userName}</span></a></li>
                                <li><a href="/" onClick={(e) => this.handleLogOut(e)}><em className="fa fa-sign-out"></em>&nbsp;&nbsp;&nbsp;<span style={{color:"#00456c"}}>Log out</span></a></li>
                              </ul>
                            </nav>
                            {/* //  : ""} */}
                          </div>
                        </nav>
                        {/* END Right Navbar */}
                        {/* END Top Navbar */}
                      </header>
                      <SnackbarWrapper />
                    </Fragment>
                  );
  }
}

Header.propTypes = {
  actions: PropTypes.object,
  settings: PropTypes.object,
};

const mapStateToProps = (state) => ({
  settings: state.settings,
  profileDetails: state.profile.profileDetails,
  form: state.form,
  version: state.profile.softwareVersion,
  email: state.login.email,
  isAuth: state.login.isAuth,
  currentEventId: state.events.currentEventId,
});
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
  logoutUser: (actionType: String) => dispatch(logoutUser(actionType)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);